import request from '@/utils/request'

/**
 * 分页查询用户列表
 * @param {Object} data - 查询参数
 * @param {number} data.pageNum - 页码
 * @param {number} data.pageSize - 每页数量
 * @param {string} data.userId - 用户ID（可选）
 * @param {string} data.phone - 手机号（可选）
 */
export function getUserPage(data) {
  return request({
    url: '/user/page',
    method: 'post',
    data
  })
}

/**
 * 获取用户详情
 * @param {string} userId - 用户ID
 */
export function getUserInfo(userId) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { userId }
  })
}

/**
 * 根据 token 获取当前用户信息
 */
export function getUserInfoByToken() {
  return request({
    url: 'manager/info/token',
    method: 'get'
  })
}
/**
 * 根据用户id查询服务商关联记录
 * @param {string} userId - 用户ID
 */
export function getProviderAssociationRecords(userId) {
  return request({
    url: '/providerAssociationRecord/listByUserId',
    method: 'get',
    params: { userId }
  })
}
